import { Reducer } from 'redux';
import { CheckInsAction } from '../actions';

const checkInsInitialState: ICheckInsState = {
  dailyCheckIns: '...',
  dailyCheckInsSubscription: null,
};

const checkInsReducer: Reducer<ICheckInsState> = (
  state = checkInsInitialState,
  action: CheckInsAction,
) => {
  switch (action.type) {
    case 'checkIns.GET_DAILY_CHECKINS':
      return { ...state, dailyCheckIns: action.payload };
    case 'checkIns.GET_DAILY_CHECKINS_SUBSCRIPTION':
      return { ...state, dailyCheckInsSubscription: action.payload };
    default:
      return state;
  }
};

export default checkInsReducer;

export interface ICheckInsState {
  dailyCheckIns: string | null;
  dailyCheckInsSubscription: null | (() => void);
}



// WEBPACK FOOTER //
// ./src/store/reducers/checkInsReducer.ts